import { GetConfig } from '../js/Utils/utils';
const baseUrl = (await GetConfig()).REACT_APP_API_URL;

const basePath = {
  chatbot: baseUrl + 'goda/chatbot/',
};
const globalVars = {
  name: 'Cloud Portal',
  apiUrl: {
    GPTGeneralChatV2Stream: basePath.chatbot + 'GPTGeneralChatV2Stream',
  },
  recaptchSitekey: {
    normal: '6Lc9p0YpAAAAAMhkCxSUhRvybzGdLH-Z5dBDzDll',
  },
};

export default globalVars;
